import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';

const Atention = () => {
  return (
    <div className='mt-2 flex items-start gap-2 rounded-sm border border-[#ffe58f] bg-[#fffbe6] px-3 py-2 text-xs'>
      <ExclamationCircleOutlined className='mt-px shrink-0 text-[#faad14]' />
      <p className='m-0 leading-relaxed text-[#614700]'>
        Links com <code className='rounded-sm bg-[#fff7e0] px-1 text-[11px]'>target=&quot;blank&quot;</code> podem não
        funcionar em páginas abertas via apps de redes sociais. Recomendamos não utilizar esse atributo.
      </p>
    </div>
  );
};

export default Atention;
